import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IHazardousMaterial } from '../models/hazardousMaterial';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class HazardousMaterialsService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getHazardousMaterials(buildingId: string): Observable<{has_error: boolean, message: string, data: IHazardousMaterial[]}> {
        const url = environment.apiBaseUrl + endpoints.getHazardousMaterials.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: IHazardousMaterial[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createHazardousMaterial(buildingId: string, data: Partial<IHazardousMaterial>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.createHazardousMaterial.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateHazardousMaterial(buildingId: string, itemId: string, data: Partial<IHazardousMaterial>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateHazardousMaterial
            .replace(':buildingId', buildingId)
            .replace(':itemId', itemId);
        return this.http.put<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }

    deleteHazardousMaterial(buildingId: string, itemId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.deleteHazardousMaterial
            .replace(':buildingId', buildingId)
            .replace(':itemId', itemId);
        return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
